var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChartSquareUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 2.50002H13.5003C14.9005 2.50002 15.6005 2.50002 16.1353 2.7725C16.6057 3.01219 16.9882 3.39464 17.2278 3.86504C17.5003 4.39982 17.5003 5.09989 17.5003 6.50002V13.5C17.5003 14.9002 17.5003 15.6002 17.2278 16.135C16.9882 16.6054 16.6057 16.9879 16.1353 17.2275C15.6005 17.5 14.9005 17.5 13.5003 17.5H6.50033C5.10019 17.5 4.40013 17.5 3.86535 17.2275C3.39494 16.9879 3.01249 16.6054 2.77281 16.135C2.50033 15.6002 2.50033 14.9002 2.50033 13.5V10M6.66699 10.8334V14.1667M13.3337 9.16669V14.1667M10.0003 5.83335V14.1667M1.66699 4.16669L4.16699 1.66669M4.16699 1.66669L6.66699 4.16669M4.16699 1.66669L4.16699 6.66669",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartSquareUp);
export default __webpack_public_path__ + "static/media/bar-chart-square-up.9d640820d8bf8e2f9aab7690613040ac.svg";
export { ForwardRef as ReactComponent };